import { lazy } from 'react'

import logo from './assets/logo.svg'

const financeModule = {
  meta: {
    logo,
    name: 'finances',
    title: 'Finanças',
    path: '/finances/dashboard'
  },
  routes: [
    {
      name: 'Dashboard',
      path: '/finances/dashboard',
      exact: true,
      component: lazy(() => import('./pages/Dashboard')),
      meta: {
        isPrivate: true
        // permissions: ['finance_dashboard:show']
      }
    },
    {
      name: 'Categories',
      path: '/finances/categories',
      exact: true,
      component: lazy(() => import('./pages/Categories')),
      meta: {
        isPrivate: true,
        permissions: ['finance_categories:list']
      }
    },
    {
      name: 'Entries',
      path: '/finances/entries',
      exact: true,
      component: lazy(() => import('./pages/Entries')),
      meta: {
        isPrivate: true,
        permissions: ['finance_entries:list']
      }
    }
  ]
}

export default financeModule
